/* Takumi™ — antraštės elgsena.
   Self-contained: shares nothing with the other kits. Installs once however
   many times the script tag is rendered. */
(function () {
  'use strict';
  if (window.TKH) return;
  var TKH = (window.TKH = {});
  TKH.version = '2026-10-27-promo';

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';

  /* ------------------------------------------------------------- drawer */
  function bindDrawer(root) {
    var drawer = root.querySelector('[data-tkh-drawer]');
    if (!drawer) return;
    var openers = $$('[data-tkh-open-btn]', root);
    var closers = $$('[data-tkh-close]', root);
    var scrim = root.querySelector('[data-tkh-scrim]');
    var lastFocus = null;

    /* The page is held still by fixing the body at its current offset rather
       than by `overflow: hidden`, which iOS Safari ignores on the body — the
       page scrolled on behind an open drawer and came back somewhere else.
       The offset is put back by hand on close. */
    var lockedAt = 0;
    function lock() {
      lockedAt = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = -lockedAt + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    function unlock() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, lockedAt);
    }

    /* Where the header ends, measured rather than assumed: the strip of
       promises above the bar and the bar's own height are both settings, and
       a sticky header hides and reveals itself as the page moves. Taken at
       the moment of opening, so it is right whatever the page was doing. */
    function placeUnderHeader() {
      /* Same reasoning as the stylesheet: act unless the other mode was
         explicitly chosen, so an empty attribute does not silently disable
         this. */
      if (root.getAttribute('data-drawer-top') === 'screen') return;
      var bar = root.querySelector('.tkh-bar');
      if (!bar) return;
      var y = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
      root.style.setProperty('--tkh-drawer-y', y + 'px');
    }

    function setOpen(on) {
      if ((root.getAttribute('data-tkh-open') === 'true') === on) return;
      root.setAttribute('data-tkh-open', on ? 'true' : 'false');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      drawer.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) {
        lastFocus = document.activeElement;
        placeUnderHeader();
        lock();
        /* Focus goes to the panel itself, not to the first button in it.
           Moving focus is what tells a screen reader the dialog has opened,
           but landing it on the close button made the browser draw its
           keyboard ring — a red circle round the cross that stayed there
           after a tap. A container with tabindex="-1" is announced just the
           same and has no ring to show. */
        drawer.focus();
      } else {
        unlock();
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
    }

    openers.forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
    closers.forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });

    document.addEventListener('keydown', function (e) {
      if (root.getAttribute('data-tkh-open') !== 'true') return;
      if (e.key === 'Escape') { setOpen(false); return; }
      if (e.key !== 'Tab') return;
      /* Keep the keyboard inside the drawer while it is open; without this the
         next Tab lands on the page behind it, which cannot be seen. */
      var items = $$(FOCUSABLE, drawer).filter(function (n) { return n.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* A drawer left open across a resize into the desktop layout would hold
       the page locked with nothing visible to close. */
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990) { setOpen(false); return; }
      if (root.getAttribute('data-tkh-open') === 'true') placeUnderHeader();
    });
    /* Measured once up front as well, so the very first opening does not start
       from the top of the screen and then jump into place. */
    placeUnderHeader();
    window.addEventListener('load', placeUnderHeader);
    TKH.closeDrawer = function () { setOpen(false); };
  }

  /* --------------------------------------------------------- submenus
     Opened on click as well as hover. Hover alone drops the panel as the
     pointer crosses the gap below the link, and a touch screen never hovers
     at all — the first tap would follow the parent link instead of opening
     anything.

     A wide panel lives outside the list item it belongs to, because inside it
     could never be the full width of the page. That means leaving the link
     fires `mouseleave` even when the pointer is heading straight into the
     panel, so closing waits a moment and is cancelled if the pointer arrives.
  */
  function bindSubmenus(root) {
    var holders = $$('[data-tkh-has-sub]', root);
    var shut;

    function panelOf(li) {
      var key = li.getAttribute('data-tkh-mega-for');
      return key ? root.querySelector('[data-tkh-mega="' + key + '"]') : null;
    }
    function set(li, on) {
      li.setAttribute('data-open', on ? 'true' : 'false');
      var b = li.querySelector('[data-tkh-sub-btn]');
      if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
      var panel = panelOf(li);
      if (panel) panel.setAttribute('data-open', on ? 'true' : 'false');
    }
    function closeAll(except) {
      holders.forEach(function (li) { if (li !== except) set(li, false); });
    }
    function open(li, on) {
      clearTimeout(shut);
      set(li, on);
      if (on) closeAll(li);
    }
    function closeSoon(li) {
      clearTimeout(shut);
      shut = setTimeout(function () { set(li, false); }, 160);
    }

    holders.forEach(function (li) {
      var btn = li.querySelector('[data-tkh-sub-btn]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        /* With a mouse the link does what a link does — the panel is already
           open from hovering, and clicking goes to the collection.
           With no hover there is nothing to open the panel, so the first tap
           opens it and the second follows the link. */
        if (window.matchMedia('(hover: hover)').matches) return;
        if (li.getAttribute('data-open') === 'true') return;
        e.preventDefault();
        open(li, true);
      });
      li.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: hover)').matches) open(li, true);
      });
      li.addEventListener('mouseleave', function () {
        if (window.matchMedia('(hover: hover)').matches) closeSoon(li);
      });
      btn.addEventListener('focus', function () { open(li, true); });
      li.addEventListener('focusout', function (e) {
        var panel = panelOf(li);
        if (li.contains(e.relatedTarget)) return;
        if (panel && panel.contains(e.relatedTarget)) return;
        set(li, false);
      });

      var panel = panelOf(li);
      if (panel) {
        panel.addEventListener('mouseenter', function () { clearTimeout(shut); });
        panel.addEventListener('mouseleave', function () {
          if (window.matchMedia('(hover: hover)').matches) closeSoon(li);
        });
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  /* ------------------------------------------- savas aukštis ir prilipimas
     The header stays in the flow and the page is pulled up behind it by the
     header's own height, so its height has to be known. It depends on the
     logo, the font and the viewport, so it is measured rather than written
     into the stylesheet.

     Pinning is the second half: in the flow the header scrolls away with the
     page, so once whatever sits above it has gone past it is switched to
     `fixed`. The switch point is that thing's height, measured too, because
     it is a section the shop can change or remove. */
  function bindPin(root) {
    var sec = root.closest ? root.closest('.shopify-section') : null;
    if (!sec) return;
    var above = 0, pinned = false;

    function measure() {
      /* Read the height while not pinned: once fixed, the element is out of
         the flow and its offset no longer says where it sits. */
      if (!pinned) {
        var r = sec.getBoundingClientRect();
        above = Math.max(0, Math.round(r.top + (window.pageYOffset || 0)));
        /* Not rounded. A header 62.4px tall pulled up by 62 leaves four
           tenths of a pixel of page showing, and on a phone that is the thin
           dark line between the header and the photograph. Two decimals is
           finer than any screen. */
        sec.style.setProperty('--tkh-own-h', (Math.ceil(r.height * 100) / 100) + 'px');
      }
    }
    function check() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var want = y > above;
      if (want === pinned) return;
      pinned = want;
      sec.setAttribute('data-tkh-pinned', want ? 'true' : 'false');
    }
    measure(); check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', function () {
      pinned = false;
      sec.setAttribute('data-tkh-pinned', 'false');
      measure(); check();
    });
    window.addEventListener('load', function () { measure(); check(); });
    /* The height settles late when a web font swaps in. */
    [300, 1200].forEach(function (ms) { setTimeout(measure, ms); });
  }

  /* --------------------------------------------------- nuolaidos kodas
     Kodas yra mygtukas: paspaudus jis nukeliauja į iškarpinę ir mygtukas pats
     pasako, kad nukeliavo. Telefone kito kelio nėra — kodo nei pasižymėsi,
     nei išlaikysi galvoje iki krepšelio.

     `navigator.clipboard` veikia tik saugiame kontekste ir tik iš naudotojo
     paspaudimo; peržiūroje per http jo nėra, tad po juo paliktas senasis
     `execCommand`. Rodinys nepriklauso nuo to, kuris suveikė: žmogui svarbu,
     kad mygtukas atsakytų, o ne kuris naršyklės būdas pasitaikė. */
  function copyText(text) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text);
        return;
      }
    } catch (e) {}
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:0;left:-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  function bindCode(root) {
    $$('[data-tkh-code]', root).forEach(function (btn) {
      var val = btn.querySelector('.tkh-code-v');
      var keep = val ? val.textContent : '';
      var done = btn.getAttribute('data-done') || 'Nukopijuota';
      var timer = null;
      btn.addEventListener('click', function () {
        copyText(btn.getAttribute('data-tkh-code') || keep);
        btn.setAttribute('data-copied', 'true');
        if (val) val.textContent = done;
        clearTimeout(timer);
        timer = setTimeout(function () {
          btn.removeAttribute('data-copied');
          if (val) val.textContent = keep;
        }, 1900);
      });
    });
  }

  function init() {
    $$('[data-tkh]').forEach(function (root) {
      if (root.getAttribute('data-tkh-bound') === 'true') return;
      root.setAttribute('data-tkh-bound', 'true');
      bindDrawer(root);
      bindPin(root);
      bindSubmenus(root);
      bindCode(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* The theme editor rebuilds a section without reloading the page. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () {
    if (TKH.closeDrawer) TKH.closeDrawer();
  });
})();
